import React from 'react';
import { Box, Typography, color } from '@kis-technologies/kis-ui';
import { KIOSK_GRAPHIC_SLOTS } from '../kioskGraphics';
import { MediaTypes, RequirementsProps } from '../types';

const Requirements = (props: RequirementsProps) => {
  const { mediaType, resourceName } = props;

  const getRecommendedResolution = (): string => {
    switch (mediaType) {
      case MediaTypes.ATTRACT_IMAGE:
        return 'Landscape: 860px by 880px \nPortrait: 880px by 880px';
      case MediaTypes.ATTRACT_VIDEO:
        return 'Landscape: 1720px by 880px \nPortrait: 880px by 1705px';
      case MediaTypes.BACKGROUND_IMAGE:
        return 'Landscape: 1920px by 1080px \nPortrait: 1080px by 1920px';
      case MediaTypes.EVENT:
      case MediaTypes.GENRE:
      case MediaTypes.VENUE:
      case MediaTypes.PROMO_CODE_IMAGE:
        return '800px by 600px (4:3 aspect ratio)';
      case MediaTypes.KIOSK_GRAPHIC:
        return KIOSK_GRAPHIC_SLOTS.find((slot) => slot.key === resourceName)?.recommendedResolution || '';
      case MediaTypes.INACTIVE_IMAGE:
        return 'Landscape: \n\tSplit-Screen: 860px by 880px \n\tFull-Screen: 1720px by 880px \nPortrait: \n\tSplit-Screen: 880px by 880px \n\tFull-Screen: 880px by 1720px';
      case MediaTypes.LOGO_IMAGE:
        return '160px by 50px';
      case MediaTypes.LOGO_IMAGE_LARGE:
        return '320px by 100px';
      case MediaTypes.SPLASH_IMAGE:
        return 'Landscape: \n\tSplit-Screen: 860px by 810px \n\tFull-Screen: 1720px by 810px \nPortrait: \n\tSplit-Screen: 880px by 820px \n\tFull-Screen: 880px by 1640px';
      case MediaTypes.LINKED_CONTENT:
      default:
        return '';
    }
  };

  const getRequirements = (): string => {
    switch (mediaType) {
      case MediaTypes.ATTRACT_VIDEO:
        return 'File format must be .mp4 or .mov \nMaximum file size allowed is 100MB';
      case MediaTypes.LOGO_IMAGE:
      case MediaTypes.LOGO_IMAGE_LARGE:
        return 'File types accepted: png \nFile size should be less than 10MB';
      default:
        return 'File types accepted: jpg, png \nFile size should be less than 10MB';
    }
  };

  return (
    <>
      <Box sx={{ marginBottom: '16px', whiteSpace: 'pre-wrap' }}>
        <Typography fontSize={12} fontWeight={600}>
          Recommended Resolution
        </Typography>
        <Typography fontSize={12}>{getRecommendedResolution()}</Typography>
      </Box>
      <Box sx={{ whiteSpace: 'pre-wrap' }}>
        <Typography fontSize={12} fontWeight={600} color={color.RED}>
          Requirements
        </Typography>
        <Typography fontSize={12}>{getRequirements()}</Typography>
      </Box>
    </>
  );
};

export default Requirements;
